import { AnalyticsGTM } from '@quicktools/shared-components/services/analytics-gtm';
import { ConverterAnalyticsEventType } from '@quicktools/shared-components/services/converter-analytics';
import ReactGA4 from 'react-ga4';

import { TOOL_NAME, VERSION } from '../../configs';

const page_name = 'main';

class Analytics extends AnalyticsGTM {
  event(action: string) {
    this.sendGaEvent(action, {
      page_name,
    });
    this.hjEvent(action);
  }

  pageOpen() {
    this.sendGaEvent(ConverterAnalyticsEventType.PAGE_OPEN, {
      page_name,
      non_interaction: true,
    });
  }
}

export default new Analytics(
  {
    VERSION,
    TOOL_NAME,
  },
  ReactGA4,
);
